import { StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const shadowStyles = {
  elevation: 2,
  shadowRadius: 4,
  shadowOpacity: 1,
  shadowColor: 'rgba(0, 0, 0, 0.16)',
  shadowOffset: {
    width: 0,
    height: 2
  }
}

const styles = StyleSheet.create({
  configBtn: {
    borderWidth: 1,
    borderRadius: 5,
    paddingVertical: 8,
    borderColor: Colors.white
  },
  error: {
    flex: 1,
    paddingBottom: 12
  },
  configTxt: {
    fontSize: 16,
    color: Colors.white,
    textAlign: 'center'
  },
  card: {
    flex: 1,
    ...shadowStyles,
    borderRadius: 5,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#00697C'
  },
  configHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 12
  },
  configDescription: {
    fontSize: 16,
    lineHeight: 20,
    paddingBottom: 24
  },
  configTitle: {
    fontSize: 18,
    paddingLeft: 12,
    fontWeight: 'bold'
  },
  white: {
    color: 'white'
  },
  offerStep: {
    paddingTop: 32,
    paddingBottom: 16,
  },
  header: {
    marginBottom: 16,
    fontWeight: 'bold',
    fontSize: Fonts.size.h4
  },
  subHeader: theme => ({
    lineHeight: 18,
    marginBottom: 24,
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.regular
  }),
  collapsibleCard: theme => ({
    borderRadius: 5,
    marginBottom: 24,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  recommendedBorder: {
    borderWidth: 1,
    borderTopLeftRadius: 0,
    borderColor: Colors.blue_two
  },
  recommendedBadge: {
    marginLeft: 1
  },
  offerTitle: {
    marginBottom: 8,
    fontWeight: 'bold',
    fontSize: Fonts.size.h5
  },
  price: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline'
  },
  offerRecap: {
    display: 'flex',
    paddingVertical: 24,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    justifyContent: 'space-between'
  },
  amount: {
    fontWeight: 'bold',
    fontSize: Fonts.size.regular
  },
  benefits: {
    backgroundColor: Colors.activeGrey
  },
  detailEntry: {
    display: 'flex',
    paddingVertical: 16,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    justifyContent: 'space-between'
  },
  text: {
    flexGrow: 1,
    textAlign: 'left',
    fontSize: Fonts.size.regular
  },
  detailsText: {
    paddingLeft: 8
  },
  icon: {
    marginRight: 24
  },
  buttonHolder: {
    borderTopWidth: 1,
    paddingVertical: 24,
    paddingHorizontal: 16,
    borderTopColor: Colors.activeGrey
  },
  includedText: {
    fontSize: 16,
    color: Colors.babyBlue
  }
})

export default styles
